export function getDisplayMonths(firstDisplayedMonth, calendarEndMonth, props, dateLib) {
  var _props$numberOfMonths = props.numberOfMonths,
    numberOfMonths = _props$numberOfMonths === void 0 ? 1 : _props$numberOfMonths;
  var months = [];
  for (var i = 0; i < numberOfMonths; i++) {
    var month = dateLib.addMonths(firstDisplayedMonth, i);
    if (calendarEndMonth && month > calendarEndMonth) {
      break;
    }
    months.push(month);
  }
  return months;
}